import axios from 'axios';
import { GetBackendUrlForGlobalFunctions } from '../../../App';
export const GetTrades = () => {
  return axios.get(
    GetBackendUrlForGlobalFunctions() + `trade/trade-assignment-tree`
  );
};

export const GetAllTrades = () => {
  return axios.get(GetBackendUrlForGlobalFunctions() + `trade`);
};
export const getTradeAssignmentDetail = (trade_id: string) => {
  return axios.get(
    GetBackendUrlForGlobalFunctions() +
      `assignment/assignment-of-trade?where=` +
      trade_id
  );
};
export const GetAssignmentOfTheTrade = (trade_id: string) => {
  const query =
    GetBackendUrlForGlobalFunctions() +
    `assignment/assignment-of-trade?where=` +
    trade_id;
  return axios.get(query);
};
